<template>
  <v-dialog v-model="dialog" width="550">
    <v-card>
      <v-card-title class="primary white--text text-uppercase">
        Cập nhật mật khẩu người dùng
        <v-spacer></v-spacer>
        <v-btn icon>
          <v-icon @click="closeDialog" class="white--text">close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text class="pt-6">
        <v-form ref="form">
          <v-text-field
            v-model="password"
            label="Mật khẩu mới"
            placeholder="Nhập mật khẩu mới"
            :append-icon="isPasswordShown ? 'visibility' : 'visibility_off'"
            :rules="[$rules.nospace, $rules.required, $rules.minLength(6)]"
            :type="isPasswordShown ? 'text' : 'password'"
            @click:append="isPasswordShown = !isPasswordShown"
            class="required"
            outlined
            dense
          />
        </v-form>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn class="ma-2" outlined light depressed @click="closeDialog">Hủy</v-btn>
        <v-spacer></v-spacer>
        <v-btn :loading="onSaveLoading" depressed class="ma-2" color="primary" medium @click="onSave">
          Lưu
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  data() {
    return {
      dialog: false,
      isPasswordShown: false,
      onSaveLoading: false,
      password: '',
      userId: ''
    }
  },
  methods: {
    ...mapActions({
      updatePassword: 'staff/updatePassword'
    }),
    openDialog(userId = '') {
      this.userId = userId
      this.dialog = true
    },
    closeDialog() {
      this.dialog = false
      this.reset()
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this))
    },
    async onSave() {
      try {
        this.onSaveLoading = true
        await this.updatePassword({ userId: this.userId, password: this.password })
        this.$alert.updateSuccess('mật khẩu')
        this.closeDialog()
      } catch (error) {
        this.$alert.updateError(error)
      } finally {
        this.onSaveLoading = false
      }
    }
  }
}
</script>
